import {Box, Typography} from "@mui/material";
import BackgroundPage from "../components/BackgroundPage";
import React from "react";
import "../pickercss.css";
import Wheel from "../components/Wheel";
import "../components/Wheel.css";

const WeightPage = ({nextPage, setUserData, userData, prvPage, percentage}) => {

  const onChange = (value) => {
    setUserData(prv => {
      return {
        ...prv, weight: Math.abs(value) === 0 ? 300 : Math.abs(value)
      }
    });
  };

  function formateDate(_relative, absolute) {
    return _relative + 1;
  }

  return (
      <Box sx={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        <BackgroundPage nextPage={nextPage} nextActive={true} percentage={percentage} prvPage={prvPage} backgroundImage={"/images/trainDaysPageImage.png"}>
          <Box sx={{display: "flex", justifyContent: "center", alignItems: "center"}}>
            <Typography sx={{maxWidth: "80%", textAlign: "center", textWrap: "wrap", color: "#FFF", fontSize: "21px", fontWeight: 700, fontFamily: "Assistant"}}>משקל?</Typography>
          </Box>
          <Box sx={{mt: "40px", display: "flex", alignItems: "center", justifyContent: "center"}}>
            <div
                style={{
                  height: "240px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: "#000",
                }}
            >
              <div style={{width: 150, height: "80%" }}>
                <Wheel
                    loop
                    initIdx={69}
                    length={300}
                    setValue={formateDate}
                    onChange={onChange}
                />
              </div>
            </div>
          </Box>
        </BackgroundPage>
      </Box>
  );
};

export default WeightPage;
